<template>
  <div class="jobs row">
    <div class="col-12">
      <div class="row">
        <section class="banner d-flex justify-content-center">
          <!-- <img src="@/assets/images/banner-escritorio.png" aria-hidden="true" /> -->
        </section>
      </div>

      <div class="row" id="oportunidades">
        <div class="col-10 mx-auto">
          <h1>Nossas oportunidades</h1>
          <Jobs :key="$route.fullPath" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Jobs from "@/components/jobs/Jobs.vue";
import MagnifyIcon from "vue-material-design-icons/Magnify.vue";
import Slider from "@/components/Slider.vue";

export default {
  name: "JobsList",

  data() {
    return {
    };
  },

  computed: {
    selectedTeam(){
      return this.$route.query.collection || null;
    },

    teamInfos() {
      return (
        this.$store.state.teams.find(
          (team) => team.slug == this.selectedTeam
        ) || {}
      );
    },
  },

  components: {
    Jobs,
    MagnifyIcon,
    Slider
  },
};
</script>

<style lang="scss" scoped>
  .jobs{
    background: #F5F5F5;
  }

  .banner {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    img{
      width: 98%;
    }
  }

  .search-box{
    width: 500px;
    box-shadow: 0px 4px 40px 0px #0000000D;
    border-radius: 30px;
    display: flex;
    align-items: center;
    padding: 0 10px;
    background-color: #fff;
    transform: translateY(-100px);
    @media (max-width: 600px){
      transform: none;
    }

    .form-control{
      min-height: 52px;
      flex-grow: 1;
      margin: 0;
      border: none;
      border-radius: inherit;
    }
    .btn{
      flex-shrink: 0;
    }
  }

  ul{
    li{
      font-family: 'gothamcond_book_italic';
      font-size: 22px;
    }
  }

  /deep/ .carousel-container{
    position: relative;
    padding-bottom: 20px;
    
    .tns-nav{
      position: absolute;
      bottom: -20px;
      left: 0;
      right: 0;
      display: flex;
      justify-content: center;
      gap: 8px;

      button{
        width: 15px;
        height: 15px;
        border-radius: 50%;
        border: none;
        background-color: #E7E7E7;
        &.tns-nav-active{
          background-color: #DCFF00;
        }
      }
    }
  }

  #oportunidades{
    h1{
      font-size: 36px;
      font-weight: 500;
      line-height: 56px;
      letter-spacing: 0em;
      text-align: center;
      color: #000000;
      margin: 0 0 30px 0;
      margin-top: 50px;

      @media (max-width: 600px){
        margin: 0 0 30px 0;
        font-size: 28px;
      }
    }
  }
</style>
